module.exports = __webpack_public_path__ + "img/3.ec026666.png";